import { MemberPolicy } from "./memberPolicy";

export class Member {
    memberId: string;
    currentProductId: number;
    currentProduct: any;
    memberPolicies: MemberPolicy[];
    username: string;
    password: string;
    firstName: string;
    lastName: string;
    infoVerified: boolean;
    dependentFeatureNotified: boolean;

    address: string;
    city: string;
    state: string;
    zipcode: string;
    phone1: string;
    dob: Date;
    active: boolean
    memberSSOProviderStatuses: Array<any>;
}


// WEBPACK FOOTER //
// ./src/app/_models/member.ts